import DataProvider from './api/dataProvider/index.js';
import Processor from './api/dataProvider/processor.js';
import { setConfig } from './config.js';
import Storage from './utils/storage.js';
export const setup = (setupOptions, { processor = new Processor() } = {}) => {
    setConfig(setupOptions);
    const { useStorage = false } = setupOptions;
    Storage.init(useStorage);
    if (processor) {
        DataProvider.setProcessor(processor);
    }
};
